module.exports = __webpack_public_path__ + "static/media/item-7.44bef5f3.png";